const services = [
  {
    icon: "ri-coupon-3-line",
    title: "Khuyến mãi khách thân thiết",
    desc: "Đăng ký tài cấp vốn để có cơ hội nhận mã giảm giá lên tới 50% chi phí dịch vụ trong tháng.",
    tone: "primary",
  },
  {
    icon: "ri-bank-card-2-line",
    title: "Trả tiền đúng hạn",
    desc: "Thực hiện nhiều khoản thanh toán khoản vay đúng hạn để nhận được nhiều tiền thưởng hơn trong tài khoản.",
    tone: "accent",
  },
  {
    icon: "ri-file-list-3-line",
    title: "Trả góp tín dụng",
    desc: "Phần thưởng độc quyền dành cho khách hàng tốt nhất: hạn mức vay lên tới 18 triệu, thời hạn vay lên tới 1 năm.",
    tone: "secondary",
  },
  {
    icon: "ri-flashlight-line",
    title: "Giải ngân trong 30 phút",
    desc: "Hồ sơ được xét duyệt tự động, tiền giải ngân trực tiếp vào tài khoản ngân hàng của bạn trong vòng tối đa 30 phút.",
    tone: "primary",
  },
];

function toneClasses(tone: string) {
  if (tone === "primary")
    return {
      iconBg: "bg-primary-100",
      iconColor: "text-primary-700",
      ring: "hover:border-primary-300",
    };
  if (tone === "accent")
    return {
      iconBg: "bg-accent-100",
      iconColor: "text-accent-700",
      ring: "hover:border-accent-300",
    };
  return {
    iconBg: "bg-secondary-100",
    iconColor: "text-secondary-800",
    ring: "hover:border-secondary-300",
  };
}

export default function Services() {
  return (
    <section id="services" className="bg-background-100 py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-4xl mx-auto text-center mb-14">
        <p className="text-primary-600 text-sm font-semibold tracking-widest uppercase mb-4">
          Dịch vụ của chúng tôi
        </p>
        <h2 className="font-heading text-foreground-950 text-3xl md:text-5xl leading-tight mb-5">
          Quyền lợi vượt trội cho khách hàng VF Money
        </h2>
        <p className="text-foreground-600 text-base md:text-lg">
          Chúng tôi mang đến mô hình vay cao cấp, cho phép bạn có một quy trình suôn
          sẻ, hiệu quả và đầy ưu đãi từ ngày đầu tiên.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-5xl mx-auto">
        {services.map((s) => {
          const cls = toneClasses(s.tone);
          return (
            <div
              key={s.title}
              className={`bg-background-50 border border-background-200/70 rounded-2xl p-7 transition-all duration-200 hover:-translate-y-1 ${cls.ring}`}
            >
              <div className={`w-14 h-14 rounded-2xl flex items-center justify-center ${cls.iconBg}`}>
                <i className={`${s.icon} text-2xl ${cls.iconColor}`}></i>
              </div>
              <h3 className="font-bold text-foreground-950 text-lg mt-5 mb-2">{s.title}</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">{s.desc}</p>
              <div className="mt-5 inline-flex items-center gap-1.5 text-primary-600 text-sm font-semibold cursor-pointer">
                Tìm hiểu thêm
                <i className="ri-arrow-right-line"></i>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}